import Input from "../../../../components/Input/Input";

const String = ({id, formik, settings = {}}) => {
    return (
        <Input
            name={id}
            label={settings.title}
            className="form"
            required={settings.required}
            value={formik.values[id]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            description={settings.description}
            error={formik.touched[id] && formik.errors[id]}
        />
    )
};

export default String;